import React from 'react';
import * as debounce from 'lodash.debounce';

const prohibitMultiCalling = debounce((props, isIncrease) => {
    if (isIncrease) {
        props.increase();
    }
    else {
        props.decrease();
    }
}, 200);

const NumberInput = (props) => (
    <div className="number-select">
        <div className="number-select__count minus" onClick={() => prohibitMultiCalling(props, false)}><i className="sicon-minus"></i></div>
        <input
            className="number-select__input"
            min="1"
            maxLength={3}
            type="number"
            name="numberInput"
            value={props.count}
            onChange={event => { }}
        />
        <div className="number-select__count plus" onClick={() => prohibitMultiCalling(props, true)}><i className="sicon-plus"></i></div>
    </div>
);

export default NumberInput;
